// @mui
import { Box, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

export default function BlockContent() {
  const { t } = useTranslation();
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <UploadIllustration sx={{ width: 220 }} />

      <Box sx={{ p: 3 }}>
        <Typography gutterBottom variant="h5">
          {t('Drop_or_Select_file')}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {t('Rajoutez_une_image_de_couverture_pour_votre_événement')}
        </Typography>
      </Box>
    </Stack>
  );
}
